import { render, staticRenderFns } from "./GInput.vue?vue&type=template&id=7d23976b&"
import script from "./GInput.vue?vue&type=script&lang=js&"
export * from "./GInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports